import React from 'react'

import { TableCell, TableHead, TableRow } from '@material-ui/core'

const EnhancedTableHead = ({ headRows }) => {
  return (
    <TableHead className='zr-thead'>
      <TableRow className='zr-tr'>
        {headRows.map((row, k) => (
          <TableCell
            className='zr-th'
            key={k}
            align={row.align || 'left'}
            style={
              row.width
                ? {
                    width: `${row.width}px`,
                    minWidth: `${row.width}px`,
                    maxWidth: `${row.width}px`
                  }
                : {}
            }
            padding='default'
          >
            {row.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default React.memo(EnhancedTableHead)
